import { z } from 'zod';
import { lt, Validation } from '@mews/framework';
import { SchemaFormDefinition } from '@mews-commander/form';

export const billNameSchema = z.object({
    name: Validation.String.Required.max(99),
});

export const billNameFormDefinition: SchemaFormDefinition<typeof billNameSchema> = {
    fields: {
        name: {
            label: lt('Name'),
            helper: lt('RenameBillHint'),
        },
    },
};

export type BillNameFormValues = z.infer<typeof billNameSchema>;
